import styled from 'styled-components';

export const Routineinner = styled.div`
    padding: calc(100vw*(51/375)) 0 calc(100vw*(60/375)) 0;
`